if (!customElements.get('section-media-dialog')) {
  class SectionMediaDialog extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      const section = this.closest('.shopify-section');
      if (!this.dialog || !section || this.controller) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.iframe = this.dialog.querySelector('iframe');
      this.trigger = Array.from(section.querySelectorAll('[data-media-dialog-open]')).find(
        (button) => button.getAttribute('aria-controls') === this.dialog.id
      );
      this.trigger?.addEventListener('click', (event) => this.open(event.currentTarget), options);
      this.dialog.querySelectorAll('[data-media-dialog-close]').forEach((button) => {
        button.addEventListener('click', () => this.close(), options);
      });
      const closeButton = this.dialog.querySelector('button[data-media-dialog-close]');
      this.dialog.querySelectorAll('[data-media-dialog-boundary]').forEach((boundary) => {
        boundary.addEventListener('focus', () => {
          const target = boundary.dataset.mediaDialogBoundary === 'start' ? this.iframe || closeButton : closeButton;
          target.focus();
        }, options);
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (!this.dialog.open) this.restore();
      }, options);
      section.addEventListener('shopify:section:unload', () => this.close(false), options);
    }

    disconnectedCallback() {
      this.close(false);
      this.controller?.abort();
      this.controller = null;
    }

    open(trigger) {
      if (this.dialog.open) return;
      SectionMediaDialog.active?.close(false);
      this.opener = trigger;
      this.previousOverflow = document.body.style.overflow;
      if (this.iframe) {
        const match = (trigger.dataset.videoUrl || '').match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
        if (match) this.iframe.src = 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1&rel=0';
      }
      this.dialog.classList.add('is-active');
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      SectionMediaDialog.active = this;
      this.dialog.querySelector('[data-media-dialog-title]').focus();
    }

    close(returnFocus = true) {
      if (!this.dialog) return;
      if (this.dialog.open) this.dialog.close();
      this.restore(returnFocus);
    }

    restore(returnFocus = true) {
      this.dialog.classList.remove('is-active');
      this.iframe?.removeAttribute('src');
      if (SectionMediaDialog.active !== this) return;
      document.body.style.overflow = this.previousOverflow;
      SectionMediaDialog.active = null;
      if (returnFocus && this.opener?.isConnected) this.opener.focus();
      this.opener = null;
    }
  }

  customElements.define('section-media-dialog', SectionMediaDialog);
}

if (!customElements.get('section-video-facade')) {
  class SectionVideoFacade extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-video-facade]');
      if (!this.button || this.controller) return;
      this.controller = new AbortController();
      this.button.addEventListener('click', () => {
        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + this.button.dataset.videoId + '?rel=0&modestbranding=1&color=white&autoplay=1';
        iframe.title = this.button.dataset.videoTitle;
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('frameborder', '0');
        this.button.replaceWith(iframe);
        iframe.focus();
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }

  customElements.define('section-video-facade', SectionVideoFacade);
}
